module.exports = __webpack_public_path__ + "static/media/10.96308eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/10.png
// module id = 1220
// module chunks = 0